module.exports = __webpack_public_path__ + "static/media/rw_main_logo_blue.2a377476.png";